<template>
	<v-app id="keep">

		<Navigation :drawer="drawer" v-on:drawed="doTrigDrawer($event)"/>
		<Toolbar :drawer="drawer" v-on:drawed="doTrigDrawer($event)"/>

		<router-view ></router-view>
 
	</v-app>
</template>

<script>
	import Navigation from "@/components/layout/Navigation"
	import Toolbar from "@/components/layout/Toolbar"

	export default {
		name: "ControllerContent",
		components:{
			Navigation,
			Toolbar
		},
		data: () => ({ 
			drawer: true, 
		}),
		methods:{
			doTrigDrawer(e){
				this.drawer = e;
			}
		} 
	}
</script>


<!--
<template>
	<div id="inspire">

		<Navigation :drawer="drawer" v-on:drawed="doTrigDrawer($event)"/>
		<Toolbar :drawer="drawer" v-on:drawed="doTrigDrawer($event)"/>

		<router-view ></router-view>
 
	</div>
</template>

<script>
	import Navigation from "@/components/layout/Navigation"
	import Toolbar from "@/components/layout/Toolbar"

	export default {
		name: "ControllerContent",
		components:{
			Navigation,
			Toolbar
		},
		data: () => ({ 
			drawer: true, 
		}),
		methods:{
			doTrigDrawer(e){
				this.drawer = e;
			}
		} 
	}
</script>
-->